/**
 * Formats VITE_BUILD_TIME for display (month/day/year, hour:minute, no seconds).
 * Uses the user's locale and timezone.
 */
export function formatFrontendBuildTimeLabel(): string {
    const iso = import.meta.env.VITE_BUILD_TIME;
    if (!iso) {
        return '';
    }
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) {
        return '';
    }
    return d.toLocaleString(undefined, {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
    });
}
